import React, {createRef, Fragment, useEffect, useState} from "react";
import {Card, Table, Space, Divider, Menu, Dropdown, Form, MenuProps} from "antd";
import {ColumnGroupType, ColumnType as AntColumnType} from "antd/lib/table/interface";
import {TableProps} from "antd/lib/table";
import {
    RedoOutlined,
    ColumnHeightOutlined,
    FullscreenOutlined,
    FullscreenExitOutlined,
} from "@ant-design/icons";
import * as Screenfull from "screenfull";


import styles from "./index.module.css";
import {SizeType} from "antd/lib/config-provider/SizeContext";
import SettingPopover, {ColumnProps} from "./settingPopover";
import SearchBar, {ColumnType as SearchableColumnType} from "./searchBar";
import {FormInstance} from "antd/lib/form";
import {useAntdTable as useFormTable} from "ahooks";
import {AntdTableResult} from "ahooks/lib/useAntdTable/types";

type ColumnType = SearchableColumnType & { permission?: string | undefined };
// type ColumnType = (ColumnGroupType<unknown>|AntColumnType<unknown>) & { permission?: string | undefined} &{search?:boolean};
export type StandardColumnsType = Array<ColumnType>;

interface StandardTableProps extends TableProps<any> {
    // editingKey?: any
    toolbar?: JSX.Element
    search?: {
        type: 'simple' | 'advance';
        changeType: () => void;
        submit: () => void;
        reset: () => void;
    };
    submit:()=>void;
    form?: FormInstance
    // editForm?: FormInstance
    columns: ColumnType[];
    extSearchColumns?: ColumnType[];
    showCard?: boolean
    showTools?: boolean
    onColumnsChange?: (columns: ColumnProps[]) => void
}

function DivComponent(props: any) {
    const {style, ...otherProps} = props
    return <div style={{background: 'white', ...style}} {...otherProps}/>
}

function StandardTable(props: StandardTableProps) {

    const {
        rowKey,
        toolbar,
        columns,
        extSearchColumns = [],
        search,
        form,
        showCard = true,
        showTools = true,
        onColumnsChange,
        submit,
        ...otherProps
    } = props;

    /**
     *  fix pagination bug
     *  修复翻页请求2次的问题
     */
    // if(!!otherProps.pagination && otherProps.pagination?.onChange){
    //     otherProps.pagination.onChange = undefined;
    // }
    /**
     * End
     */
    const {reset} = search as any || {};
    const [selectedSize, setSelectedSize] = useState('middle')
    const [isFullscreen, setFullscreen] = useState(false)
    const [topColumns, setTopColumns] = useState<ColumnProps[]>([])
    const [midColumns, setMidColumns] = useState<ColumnProps[]>([])
    const [bottomColumns, setBottomColumns] = useState<ColumnProps[]>([])
    const [realColumns, setRealColumns] = useState<ColumnProps[]>([])


    let ref = createRef<HTMLDivElement>()

    useEffect(() => {
        let rc = [...topColumns, ...midColumns, ...bottomColumns].filter(item => item.checked)
        setRealColumns(rc)
        onColumnsChange?.(rc)
    }, [topColumns, midColumns, bottomColumns])

    function onRefresh() {
        submit && submit()
    }

    const sizeMenus = {
        selectedKeys: [selectedSize],
        onClick: ({key})=>setSelectedSize(key),
        items: [
            {key: 'default', label: 'Large'},
            {key: 'middle', label: 'Middle'},
            {key: 'small', label: 'Compact'}
        ]
    } as MenuProps

    function onFullscreen() {
        if (Screenfull.isEnabled && ref.current) {
            Screenfull.toggle(ref.current).then(() => {
                setFullscreen(!isFullscreen)
            })
        }
    }

    function onSubmit() {
        submit && submit()
    }

    function onReset() {
        reset && reset()
    }

    // const searchColumns = columns.filter((item: any) => item.search);
    const searchColumns = [...columns.filter((item: any) => !!item.search), ...extSearchColumns];

    const CardElement = showCard ? Card : DivComponent

    /*const Index = {
        body: {
            cell: EditCellComponent
        }
    }*/
    return (
        <div ref={ref} style={{background: '#f0f2f5'}}>
            {(search && searchColumns && searchColumns.length > 0 && form) && (
                <CardElement style={showCard ? {marginBottom: 15} : {paddingBottom: 15}}>
                    <SearchBar form={form} columns={searchColumns} onSubmit={onSubmit} onReset={onReset}/>
                </CardElement>
            )}
            <CardElement>
                <div className={styles.toolbar}
                     style={showTools ? {} : {height: 0, overflow: "hidden", marginBottom: 0}}>
                    <div className={styles.operations}>
                        {toolbar && (
                            <>
                                {toolbar}
                                <Divider style={{margin: '0 15px'}} type={"vertical"}/>
                            </>
                        )}
                    </div>
                    <Space size={25}>
                        <div className={styles.toolbarItem} onClick={onRefresh}><RedoOutlined/></div>
                        <div className={styles.toolbarItem}>
                            <Dropdown trigger={['click']} menu={sizeMenus}><ColumnHeightOutlined/></Dropdown>
                        </div>
                        <div>
                            <SettingPopover columns={columns} onChange={(top, mid, bottom) => {
                                setTopColumns(top)
                                setMidColumns(mid)
                                setBottomColumns(bottom)
                            }}/>
                        </div>
                        <div className={styles.toolbarItem} onClick={onFullscreen}>
                            {isFullscreen ? <FullscreenExitOutlined/> : <FullscreenOutlined/>}</div>
                    </Space>
                </div>
                <Table rowKey={rowKey} size={selectedSize as SizeType}
                       sticky
                       columns={realColumns as any} {...otherProps} />
            </CardElement>
        </div>
    )
}

export default StandardTable
